import { render, staticRenderFns } from "./TariffCategorySelect.vue?vue&type=template&id=d885b430&scoped=true"
import script from "./TariffCategorySelect.vue?vue&type=script&lang=js"
export * from "./TariffCategorySelect.vue?vue&type=script&lang=js"
import style0 from "./TariffCategorySelect.vue?vue&type=style&index=0&id=d885b430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d885b430",
  null
  
)

export default component.exports